// @ts-nocheck

import * as Apollo from "@apollo/client";

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";

const defaultOptions = {} as const;
export type CreatePropertyMutationVariables = APITypes.Exact<{
  data: APITypes.CreatePropertyInput;
}>;

export type CreatePropertyMutation = { createProperty: boolean };

export type UpdatePropertyMutationVariables = APITypes.Exact<{
  data: APITypes.UpdatePropertyInput;
}>;

export type UpdatePropertyMutation = { updateProperty: boolean };

export type DeletePropertyMutationVariables = APITypes.Exact<{
  data: APITypes.DeletePropertyInput;
}>;

export type DeletePropertyMutation = { deleteProperty: boolean };

export type ValidateAddressInLocalizationMutationVariables = APITypes.Exact<{
  payload: APITypes.ValidateAddressInLocalizationInput;
}>;

export type ValidateAddressInLocalizationMutation = { validateAddressInLocalization: boolean };

export const CreatePropertyDocument = gql`
    mutation CreateProperty($data: CreatePropertyInput!) {
  createProperty(data: $data)
}
    `;
export type CreatePropertyMutationFn = Apollo.MutationFunction<
  CreatePropertyMutation,
  CreatePropertyMutationVariables
>;

/**
 * __useCreatePropertyMutation__
 *
 * To run a mutation, you first call `useCreatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPropertyMutation, { data, loading, error }] = useCreatePropertyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreatePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<CreatePropertyMutation, CreatePropertyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreatePropertyMutation, CreatePropertyMutationVariables>(
    CreatePropertyDocument,
    options,
  );
}
export type CreatePropertyMutationHookResult = ReturnType<typeof useCreatePropertyMutation>;
export type CreatePropertyMutationResult = Apollo.MutationResult<CreatePropertyMutation>;
export type CreatePropertyMutationOptions = Apollo.BaseMutationOptions<
  CreatePropertyMutation,
  CreatePropertyMutationVariables
>;
export const UpdatePropertyDocument = gql`
    mutation UpdateProperty($data: UpdatePropertyInput!) {
  updateProperty(data: $data)
}
    `;
export type UpdatePropertyMutationFn = Apollo.MutationFunction<
  UpdatePropertyMutation,
  UpdatePropertyMutationVariables
>;

/**
 * __useUpdatePropertyMutation__
 *
 * To run a mutation, you first call `useUpdatePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePropertyMutation, { data, loading, error }] = useUpdatePropertyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdatePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdatePropertyMutation, UpdatePropertyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdatePropertyMutation, UpdatePropertyMutationVariables>(
    UpdatePropertyDocument,
    options,
  );
}
export type UpdatePropertyMutationHookResult = ReturnType<typeof useUpdatePropertyMutation>;
export type UpdatePropertyMutationResult = Apollo.MutationResult<UpdatePropertyMutation>;
export type UpdatePropertyMutationOptions = Apollo.BaseMutationOptions<
  UpdatePropertyMutation,
  UpdatePropertyMutationVariables
>;
export const DeletePropertyDocument = gql`
    mutation DeleteProperty($data: DeletePropertyInput!) {
  deleteProperty(data: $data)
}
    `;
export type DeletePropertyMutationFn = Apollo.MutationFunction<
  DeletePropertyMutation,
  DeletePropertyMutationVariables
>;

/**
 * __useDeletePropertyMutation__
 *
 * To run a mutation, you first call `useDeletePropertyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePropertyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePropertyMutation, { data, loading, error }] = useDeletePropertyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useDeletePropertyMutation(
  baseOptions?: Apollo.MutationHookOptions<DeletePropertyMutation, DeletePropertyMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeletePropertyMutation, DeletePropertyMutationVariables>(
    DeletePropertyDocument,
    options,
  );
}
export type DeletePropertyMutationHookResult = ReturnType<typeof useDeletePropertyMutation>;
export type DeletePropertyMutationResult = Apollo.MutationResult<DeletePropertyMutation>;
export type DeletePropertyMutationOptions = Apollo.BaseMutationOptions<
  DeletePropertyMutation,
  DeletePropertyMutationVariables
>;
export const ValidateAddressInLocalizationDocument = gql`
    mutation ValidateAddressInLocalization($payload: ValidateAddressInLocalizationInput!) {
  validateAddressInLocalization(payload: $payload)
}
    `;
export type ValidateAddressInLocalizationMutationFn = Apollo.MutationFunction<
  ValidateAddressInLocalizationMutation,
  ValidateAddressInLocalizationMutationVariables
>;

/**
 * __useValidateAddressInLocalizationMutation__
 *
 * To run a mutation, you first call `useValidateAddressInLocalizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useValidateAddressInLocalizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [validateAddressInLocalizationMutation, { data, loading, error }] = useValidateAddressInLocalizationMutation({
 *   variables: {
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useValidateAddressInLocalizationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ValidateAddressInLocalizationMutation,
    ValidateAddressInLocalizationMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ValidateAddressInLocalizationMutation,
    ValidateAddressInLocalizationMutationVariables
  >(ValidateAddressInLocalizationDocument, options);
}
export type ValidateAddressInLocalizationMutationHookResult = ReturnType<
  typeof useValidateAddressInLocalizationMutation
>;
export type ValidateAddressInLocalizationMutationResult =
  Apollo.MutationResult<ValidateAddressInLocalizationMutation>;
export type ValidateAddressInLocalizationMutationOptions = Apollo.BaseMutationOptions<
  ValidateAddressInLocalizationMutation,
  ValidateAddressInLocalizationMutationVariables
>;
